import * as React from 'react'
import { memo } from 'react'
const SvgStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12.923 12"
  >
    <path d="M12.433 4.154H8.189L6.9.306a.467.467 0 0 0-.877 0L4.734 4.154H.462A.463.463 0 0 0 0 4.616a.3.3 0 0 0 .009.078.44.44 0 0 0 .193.326L3.69 7.478l-1.34 3.89a.46.46 0 0 0 .159.519.45.45 0 0 0 .26.112.57.57 0 0 0 .288-.1l3.4-2.426 3.4 2.426a.54.54 0 0 0 .288.1.4.4 0 0 0 .257-.112.46.46 0 0 0 .159-.519L9.223 7.477l3.459-2.481.084-.072a.441.441 0 0 0-.34-.77Z" />
  </svg>
)
const Memo = memo(SvgStar)
export default Memo
